module.exports = __webpack_public_path__ + "static/media/saastopossu-black.0bf3aba0.svg";